export default {
  reviews: {
    id: 'product_reviews_top',
    defaultMessage: '{ count } reviews',
  },
}
